import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import PageSeo from '../components/PageSeo';
import { SEO } from '../utils/seoConfig';

export default function LegalNotice() {
  return (
    <div className="min-h-screen bg-[#F5F5F5] py-12">
      <PageSeo {...SEO.legalNotice} />
      <div className="container mx-auto px-4 max-w-4xl">
        <Card>
          <CardContent className="p-8">
            <h1 className="text-3xl font-bold text-[#0A2540] mb-6">
              Mentions Légales
            </h1>

            <div className="space-y-6 text-gray-700">
              {/* Éditeur */}
              <section>
                <h2 className="text-xl font-bold text-[#0A2540] mb-3">
                  Éditeur du Site
                </h2>
                <ul className="list-none space-y-1 text-sm">
                  <li><strong>GEO TS CONSULTING</strong> (GEO TECHNICAL SPARES)</li>
                  <li>SAS au capital de [À compléter] €</li>
                  <li>26 Rue des Rigoles, 75020 PARIS</li>
                  <li>SIRET : 993 093 772 00016</li>
                  <li>TVA : FR48 993 093 772</li>
                  <li>📧 contact@geots.consulting</li>
                  <li>📞 +33 1 64 40 95 27</li>
                </ul>
              </section>

              {/* Hébergement */}
              <section>
                <h2 className="text-xl font-bold text-[#0A2540] mb-3">
                  Hébergement
                </h2>
                <p className="text-sm">
                  <strong>OVHcloud</strong> - 2 rue Kellermann, 59100 Roubaix, France
                </p>
              </section>

              {/* Propriété intellectuelle */}
              <section>
                <h2 className="text-xl font-bold text-[#0A2540] mb-3">
                  Propriété Intellectuelle
                </h2>
                <p className="text-sm">
                  L'ensemble du site (textes, images, graphismes) est la propriété exclusive de GEO TS CONSULTING. Toute reproduction sans autorisation est interdite.
                </p>
              </section>

              {/* Données personnelles */}
              <section>
                <h2 className="text-xl font-bold text-[#0A2540] mb-3">
                  Données Personnelles
                </h2>
                <p className="text-sm mb-2">
                  Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données.
                </p>
                <Link to="/privacy-policy" className="text-[#635BFF] hover:underline text-sm font-medium">
                  → Politique de Confidentialité
                </Link>
              </section>

              {/* Droit applicable */}
              <section>
                <h2 className="text-xl font-bold text-[#0A2540] mb-3">
                  Droit Applicable
                </h2>
                <p className="text-sm">
                  Les présentes mentions légales sont régies par le droit français. Tribunaux compétents : Paris.
                </p>
              </section>
            </div>

            {/* Retour */}
            <div className="mt-8 pt-4 border-t">
              <Link 
                to="/" 
                className="text-[#635BFF] hover:text-[#5248d9] font-medium text-sm"
              >
                ← Retour à l'accueil
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
